import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ScholarshipType } from "../../../types/Scholarship";

const initialState: ScholarshipType = {
    idStudent: "",
    studentCode: "",
    idScholarshipType: "",
    idScholarshipProvider: "",
    startDate: "",
    endData: "",
    percent: 0,
    status: false
};

export const scholarshipSlice = createSlice({
    name: "scholarshipForm",
    initialState,
    reducers: {
        setScholarshipData: (state, action: PayloadAction<ScholarshipType>) => {
            return { ...state, ...action.payload };
        },
        resetScholarshipData: () => {
            return initialState;
        }
    }
});

export const { setScholarshipData, resetScholarshipData } = scholarshipSlice.actions;
export default scholarshipSlice.reducer;
